import dayjs from 'dayjs'
import 'dayjs/locale/th'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'

// Configure dayjs
dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('th')

// Format date with Thai locale
export function fDate(dateInput: string | Date | dayjs.Dayjs): string {
  const date = dayjs(dateInput)
  if (!date.isValid()) return '-'
  return date.format('DD/MM/YYYY')
}

// Format date with time
export function fDateTime(dateInput: string | Date | dayjs.Dayjs): string {
  const date = dayjs(dateInput)
  if (!date.isValid()) return '-'
  return date.format('DD/MM/YYYY HH:mm')
}

// Format time only
export function fTime(dateInput: string | Date | dayjs.Dayjs): string {
  const date = dayjs(dateInput)
  if (!date.isValid()) return '-'
  return date.format('HH:mm')
}

// Format relative time (e.g., "2 hours ago")
export function fToNow(dateInput: string | Date | dayjs.Dayjs): string {
  const date = dayjs(dateInput)
  if (!date.isValid()) return '-'
  return date.fromNow()
}

// Check if date is today
export function isToday(dateInput: string | Date | dayjs.Dayjs): boolean {
  const date = dayjs(dateInput)
  if (!date.isValid()) return false
  return date.isSame(dayjs(), 'day')
}

// Format date for datetime-local input
export function formatForDateTimeLocal(
  dateInput: string | Date | dayjs.Dayjs,
): string {
  const date = dayjs(dateInput)
  if (!date.isValid()) return ''
  return date.format('YYYY-MM-DDTHH:mm')
}

// Parse datetime-local input to dayjs
export function parseFromDateTimeLocal(value: string): dayjs.Dayjs | null {
  if (!value) return null
  const date = dayjs(value)
  return date.isValid() ? date : null
}

// Get current date as dayjs
export function now(): dayjs.Dayjs {
  return dayjs()
}

// Create dayjs from various inputs
export function createDate(
  dateInput: string | Date | dayjs.Dayjs,
): dayjs.Dayjs {
  return dayjs(dateInput)
}
